import ActionDataInterface from 'Components/Action/Interface/ActionData';

const ActionData: ActionDataInterface[] = [];

export default ActionData;
